import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=1ad93d04&scoped=true&"
import script from "./InsightCard.vue?vue&type=script&lang=js&"
export * from "./InsightCard.vue?vue&type=script&lang=js&"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=1ad93d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad93d04",
  null
  
)

export default component.exports